// src/pages/FeedbackPage.js
import React, { useState } from 'react';
import FeedbackForm from '../components/FeedbackForm';
import FeedbackSuccess from '../components/FeedbackSuccess';

const FeedbackPage = () => {
    const [submitted, setSubmitted] = useState(false);

    const handleFormSuccess = () => {
        setSubmitted(true);
    };

    return submitted ? <FeedbackSuccess /> : <FeedbackForm onSuccess={handleFormSuccess} />;
};

export default FeedbackPage;